import React from 'react';
import { Award, BookOpen, Shield } from 'lucide-react';
import { AnimatedSection } from './AnimatedSection';
export function VideoCourseTrust() {
  return <AnimatedSection className="py-16 bg-warm-white" data-id="element-161">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-162">
        <div className="bg-warm-gray-50 rounded-2xl p-8 lg:p-10 border border-warm-gray-200" data-id="element-163">
          <div className="flex flex-col md:flex-row items-center gap-8" data-id="element-164">
            <div className="flex-grow" data-id="element-165">
              <h3 className="font-heading text-xl text-primary-900 mb-4" data-id="element-166">
                Professional-Grade Curriculum
              </h3>
              <ul className="space-y-3 font-body text-warm-gray-700 text-sm" data-id="element-167">
                <li className="flex items-center gap-3" data-id="element-168">
                  <Award className="w-5 h-5 text-accent-500 shrink-0" data-id="element-169" />
                  <span data-id="element-170">
                    Pet Tech–based curriculum and training methodology
                  </span>
                </li>
                <li className="flex items-center gap-3" data-id="element-171">
                  <BookOpen className="w-5 h-5 text-accent-500 shrink-0" data-id="element-172" />
                  <span data-id="element-173">Industry-aligned emergency training protocols</span>
                </li>
                <li className="flex items-center gap-3" data-id="element-174">
                  <Shield className="w-5 h-5 text-accent-500 shrink-0" data-id="element-175" />
                  <span data-id="element-176">Designed for real-world pet care situations</span>
                </li>
              </ul>
            </div>
            <div className="flex gap-4 shrink-0" data-id="element-177">
              <div className="w-20 h-20 rounded-2xl bg-white border border-warm-gray-200 shadow-warm-sm flex flex-col items-center justify-center" data-id="element-178">
                <span className="font-heading text-xs text-primary-800 text-center leading-tight" data-id="element-179">
                  PET TECH
                </span>
              </div>
              <div className="w-20 h-20 rounded-2xl bg-white border border-warm-gray-200 shadow-warm-sm flex flex-col items-center justify-center" data-id="element-180">
                <span className="font-heading text-sm text-primary-800" data-id="element-181">
                  PACCC
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AnimatedSection>;
}